import React, { useMemo, useState } from 'react';
import "../RequestCards.css";
import img1 from "../../../assets/Hotels/checkInRequest.png";
import button from "../../../assets/icons/ShadowButton.svg";
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { baseUrl } from '../../../common/baseUrl.js';
import axiosInstance from '../../../axiosInstance/axiosInstance.js';
import { isReviewable } from "../../../common/reviewStatus";

export default function CheckInCard(props) {
  const navigate = useNavigate();

  const [usersData,setUsersData] = useState([]);

  const [guests, setGuests] = useState([]);

  const formattedStatus = useMemo(() => {
    if(props.status==="Declined_Guest"){
      return "Cancelled Guest"
    }
    return props.status.replace('_', ' ');
  }, [props.status]);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sept", "Oct", "Nov", "Dec"];
    const month = monthNames[date.getMonth()];
    const day = date.getDate();
    return `${month} '${day}`;
  };

  const formattedActive = useMemo(() => {
  
    return props.activeTab ;
  }, [props.activeTab]);


 
  // Fetch guests based on booked room IDs
  const fetchGuests = async (id) => {
    try {
      const response = await axiosInstance.get(`/api/v1/users/${props.userId}/bookings/${props.bookingId}/booked-rooms/${id}/guest-requests/web-checkin`);
      return { id, data: response.data.guest_details }; // Return both ID and guest details

    } 
    catch (error) {
      toast.error("Some Error Occured");
      console.error(`Error for ID ${id}:`, error.message || error);
      return { id, data: null }; // Return ID with null data in case of an error
    }
  };

 
  const handleClickLatest = () => {
      navigate(`/requests/${props.guestRequestId}`);
  };

  const editReviewModal = ()=>{
    try{
        props.setIsReviewModal(!props.isReviewModal)

        console.log("Booking ID : ",props.bookingId);
        console.log("Booked Room ID : ",props.bookedRoomId);
        console.log("Guest Request ID : ",props.guestRequestId);

        props.setRequestData({
            bookingId: props.bookingId,
            bookedRoomId: props.bookedRoomId,
            guestRequestId: props.guestRequestId,
            ratingRemarks : props?.rating_remark || "",
            rating : props?.rating || 0,
            view : "view"
        })

    }catch(error){
      console.log(error);
    }
  }

  return (
    <>
      <div className='request-card'  onClick={handleClickLatest}>
        <div className='request-card-date'>
          <p>Web CheckIn Request</p>
        </div>
        <div className='request-card-main'>
          <div className='request-card-side1'>
            <div className='request-card-header'>
              <h4>Web CheckIn</h4>
            </div>
            <div className='request-card-para'>
              <p style={{ fontSize: '13px', marginTop: '4px' }}>
                {props.hotelName}
              </p>
              <p style={{ fontSize: '11px', marginTop: '4px' }}>
                {formatDate(props.checkInDate)} - {formatDate(props.checkOutDate)}
              </p>
              <p style={{ color: "#ACB8C2", fontSize: '11px', marginTop: '4px' }}>
                {props.hotelAddress}
                 
              </p>

              {/* Review and Status */}
              <div className='request-card-checkin'>
                <div className="request-card-badge">
                  {
                    formattedStatus === "Combine"  ? 
                    formattedActive === "All" ? 
                    <span>Pending Hotel</span>
                    :
                    <span>{formattedActive}</span>
                    : 
                    <span>{formattedStatus}</span>
                  }
                </div>
                {(isReviewable(props.status) && props.is_rating_given) &&   <span className='rate-us' onClick={(e)=>{e.stopPropagation();editReviewModal();}}>view rating</span>}
              
              </div>

            </div>

            <div className='request-card-button' >
              <img src={button} alt="Redirect button" />
            </div>
          </div>

          <div className='request-card-side2'>
            <div className='request-card-img'>
              <img src={img1} alt="" />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}